import template from './view-cart-options.html';
import controller from './view-cart-options.controller';

let viewCartOptionsComponent = {
        restrict: 'E',
        bindings: {
            cart: '<',
            viewCartModel: '<',
            checkoutLink: '<',
            hasInvalidProducts: '<',
            continueShoppingLink: '<',
            shoppingCartForm: '<'
    },
    template,
    controller
};

export default viewCartOptionsComponent;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-options/view-cart-options.component.js